import { Component, HostListener } from '@angular/core';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { Detail, DetailObj } from 'src/app/shared/interfaces/trip-history';

@Component({
  selector: 'trip-leg-history-timeline',
  templateUrl: './leg-history-timeline.component.html',
  styleUrls: ['./leg-history-timeline.component.scss']
})
export class LegHistoryTimelineComponent {
  visibility: boolean = false;
  title: string = 'Leg History';
  legName: string;
  data: Detail;
  logType: number;
  date: string;

  constructor(
    private readonly dialogService: DialogService,
  ) {}

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    if(this.dialogService.isTopMost(this)) {
      this.hide();
    }
  }

  hide() {
    this.visibility = false;
    this.dialogService.unregisterDialog(this);
  }

  show() {
    this.visibility = true;
    this.dialogService.registerDialog(this);
  }

  getDetails() {
    if(this.data) {
      const detailObjs = (Object.values(this.data) as DetailObj[]).reverse();
      return detailObjs;
    }
    return [];
  }
}
